import { now, Log ,MyPIXIContainer } from "./MyHelpers";
import { IBonusStartConfig } from "./slot/SlotGame";
import { SlotGameInitData } from "./SlotGameInitData";
import { EnglishTranslation, SpanishTranslation, Translator } from "./Translator";
import { JackpotLevel, JackpotValue2, JackpotValuesUpdateParams, LoadInfo } from "./api";



interface IScreenProtocolMessage
{
	msg: string;
	scope: string;
	from: string;
	to: string;
}

export class ScreenProtocolMessage implements IScreenProtocolMessage {
	public msg: string;
	public scope: string
	public from: string;
	public to: string;

	constructor(msg: string) {
		this.msg = msg;
	}
}



// class ScreenDisconnectMessage extends ScreenProtocolMessage
// {
// 	public static readonly msgname = "disconnect";

// 	constructor() {
// 		super(ScreenIntroductionMessage.msgname);
// 	}
// }

export class ScreenProtocolScope
{
	protected path: string[] = [];

	public scope: string = null;
	constructor(scope: string | string[]) {

		if (scope == null) {
			debugger;
		}
		else if (typeof scope == "string" ) {
			this.path.push(scope);
		}
		else {
			for (let i = 0; i < scope.length; i++) this.path.push(scope[i]);
		}

		this.scope = this.path.join(".");
	}

	public Add(scope: string) {
		let newPath: string[] = [];
		for (let i = 0; i < this.path.length; i++) newPath.push(this.path[i]);

		newPath.push(scope);
		return new ScreenProtocolScope(newPath);
	}
}

export class ScreenProtocolDestination
{
	public static readonly Broadcast: ScreenProtocolDestination = new ScreenProtocolDestination("*");

	destination: string = null;
	constructor(destination: string) {
		this.destination = destination;
	}
}


export type ScreenConnectionLostCallback = (screen: OtherScreen) => void;
export type ScreenConnectionRestoredCallback = (screen: OtherScreen) => void;
export class OtherScreen
{
	public name: string;
	public lastInteraction: number;
	public maxTimeWithoutInteraction: number;
	public pingInterval: number;

	protected timer: number = -1;
	protected connectionLost: boolean = false;

	protected connectionLostCallback: ScreenConnectionLostCallback = null;
	protected connectionRestoredCallback: ScreenConnectionRestoredCallback = null;

	public constructor(name: string,/* pingInterval: number,*/ maxTimeWithoutInteraction: number, connectionLostCallback: ScreenConnectionLostCallback = null, connectionRestoredCallback = null) {
		this.name = name;
		this.lastInteraction = now();
		/*this.pingInterval = pingInterval;*/
		this.maxTimeWithoutInteraction = maxTimeWithoutInteraction;

		this.OnConnectionLost(connectionLostCallback);
		this.OnConnectionRestored(connectionRestoredCallback);
	}

	public ResetLastInteraction(): void {
		if (this.connectionLost) {
			if (this.connectionRestoredCallback != null)
				this.connectionRestoredCallback(this);

			this.connectionLost = false;
		}


		this.lastInteraction = now();

		if (this.timer != -1) {
			clearTimeout(this.timer);
			this.timer = -1;
		}

		this.timer = window.setTimeout(() => this.ConnectionLost(), this.maxTimeWithoutInteraction);
	}

	protected ConnectionLost() {
		// Log.Debug("OtherScreen", "Connection lost to " + this.name + ", last interaction " + (now() - this.lastInteraction) + "ms ago");
		this.connectionLost = true;

		if (this.connectionLostCallback != null) {
			this.connectionLostCallback(this);
		}
	}

	public OnConnectionLost(callback: ScreenConnectionLostCallback) {
		this.connectionLostCallback = callback;
	}

	public OnConnectionRestored(callback: ScreenConnectionRestoredCallback) {
		this.connectionRestoredCallback = callback;
	}
}


export type ScreenProtocolMessageHandler = (message: IScreenProtocolMessage) => void


// export class SimpleScreenComms
// {
// 	protected connected: boolean = false;
// 	protected screenName: string;
// 	protected channelName: string;
// 	protected logGroup: string;

// 	public constructor(screenName: string, channelName: string = "ScreenChannel", isLocal: boolean = false) 
// 	{
// 		this.screenName = screenName;
// 		this.channelName = channelName;
// 		this.logGroup = "ScreenProtocol|" + this.channelName;

// 	}
// 	public Send(message: IScreenProtocolMessage,  scope: ScreenProtocolScope/* = null*/, destination: ScreenProtocolDestination = ScreenProtocolDestination.Broadcast) {
// 			message.from = this.screenName;
// 			message.to = destination.destination;
// 			message.scope = scope.scope;

// 			// if (message.msg != "ping")
// 			// 	// Log.Debug(this.logGroup, "Sending message " + message.scope + "." + message.msg + " from " + message.from + " to " + message.to, message);

// 			this.broadcastChannel.postMessage(JSON.stringify(message));

// 			let messageHandler: ScreenProtocolMessageHandler = null;

// 			messageHandler = this.sendMessageHandler.get(ScreenProtocol.AnyMessage);
// 			if (messageHandler) {
// 				messageHandler(message);
// 			}

// 			messageHandler = this.sendMessageHandler.get(message.msg)
// 			if (messageHandler != null) {
// 				messageHandler(message);
// 			}
// 		}
// 		else {
// 			// Log.Debug(this.logGroup, "Can't send message, not connected");
// 		}
// 	}
// }



let pubSubInstances: PubSub[] = [];
export class PubSub
{
	public constructor()
	{
		pubSubInstances.push(this);
	}

	public postMessage(message: IScreenProtocolMessage)
	{
		for (let pubSubInstance of pubSubInstances)
		{
			if (pubSubInstance !== this)
			{
				pubSubInstance.onmessage?.(message);
			}
		}
	}

	public onmessage: (message: IScreenProtocolMessage) => void = null;
	//public onmessageerror: (ev: MessageEvent) => void = null;
}




export class ScreenProtocol {

	protected connected: boolean = false;
	protected screenName: string;
	protected channelName: string;
	protected logGroup: string;
	protected remoteNodes: string;

	//protected broadcastChannel: BroadcastChannel;
	protected pubsub: PubSub = new PubSub();
	public static readonly AnyMessage: string = "*";

	protected scope: ScreenProtocolScope = new ScreenProtocolScope("p");
	protected otherScreens: Map<string, OtherScreen> = new Map<string, OtherScreen>();

	protected pingEnabled: boolean = false;
	protected pingTimer: number = -1;
	protected pingInterval: number = 0;
	protected pingMessage: IScreenProtocolMessage = new ScreenPingMessage();
	//public translation : Translator = new Translator(EnglishTranslation);
    
	public constructor(screenName: string, channelName: string = "ScreenChannel", isLocal: boolean = false) {
		this.screenName = screenName;
		this.channelName = channelName;
		this.logGroup = "ScreenProtocol|" + this.channelName;
		//this.translator.LoadTranslation(SpanishTranslation);

        // this.translation.LoadTranslation(EnglishTranslation);
		// this.translation.LoadTranslation(SpanishTranslation);

		//this.AddMessageHandler("proto.introduction", (message: IScreenProtocolMessage) => this.OnIntroduction(message));

		//this.broadcastChannel = new BroadcastChannel(this.channelName);
		//this.broadcastChannel.onmessage = (ev: MessageEvent) => this.OnMessageReceived(ev);
		//this.broadcastChannel.onmessageerror = (ev: MessageEvent) => this.OnMessageError(ev);

		this.pubsub.onmessage = (msg) => this._OnMessageReceived(msg);

		this.AddReceiveMessageHandler(ScreenPingMessage.msgname, (message: IScreenProtocolMessage) => this.OnPingReceived(<ScreenPingMessage>message), "p");
		this.AddReceiveMessageHandler(ScreenIntroductionMessage.msgname, (message: IScreenProtocolMessage) => this.OnIntroduction(message), "p");
	}
	
	public settranslot(translator:Translator):void{
	}

	// public gettrans(){
	// 	return this.translation;
	// }




	public Scope(): ScreenProtocolScope {
		return this.scope;
	}

	public Connect(): void {
		this.connected = true;
		this.Send(new ScreenIntroductionMessage(this.screenName), this.scope);

		if (this.pingEnabled) {
			this.StartPingTimer();

			// start checking keep alive
			this.otherScreens.forEach((otherScreen) => {
				otherScreen.ResetLastInteraction();
			});
		}
	}

	public SetKeepAlive(interval: number): void {
		this.pingInterval = interval;
		this.pingEnabled = true;

		if (this.connected) {
			this.StartPingTimer();
		}
	}

	public StopKeepAlive(): void {
		this.pingEnabled = false;
		this.StopPingTimer();
	}

	protected StartPingTimer() {
		this.StopPingTimer();
		this.pingTimer = window.setInterval(() => this.OnPingTimer(), this.pingInterval);
	}

	protected StopPingTimer() {
		if (this.pingTimer != -1) {
			clearInterval(this.pingTimer);
			this.pingTimer = -1;
		}
	}

	protected OnPingTimer(): void {
		this.Send(this.pingMessage, this.scope)
	}

	protected OnPingReceived(message: ScreenPingMessage): void {
		// nothing to do...
	}

	// public Disconnect() {
	// 	debugger;
	// 	if (this.connected) {
	// 		this.Send(new ScreenDisconnectMessage());
	// 	}
	// 	this.connected = false;
	// 	//this.Send(new ScreenIntroductionMessage(this.screenName));
	// }

	public Send(message: IScreenProtocolMessage,  scope: ScreenProtocolScope/* = null*/, destination: ScreenProtocolDestination = ScreenProtocolDestination.Broadcast) {
		if (this.connected) {
			message.from = this.screenName;
			message.to = destination.destination;
			message.scope = scope.scope;

			// if (message.msg != "ping")
			// 	// Log.Debug(this.logGroup, "Sending message " + message.scope + "." + message.msg + " from " + message.from + " to " + message.to, message);

			this.pubsub.postMessage(message);

			let messageHandler: ScreenProtocolMessageHandler = null;

			messageHandler = this.sendMessageHandler.get(ScreenProtocol.AnyMessage);
			if (messageHandler) {
				messageHandler(message);
			}

			messageHandler = this.sendMessageHandler.get(message.msg)
			if (messageHandler != null) {
				messageHandler(message);
			}
		}
		else {
			// Log.Debug(this.logGroup, "Can't send message, not connected");
		}
	}

	protected OnMessageReceived(ev: MessageEvent) {
		if (this.connected) {
			let message: IScreenProtocolMessage = <IScreenProtocolMessage>JSON.parse(ev.data);

			this._OnMessageReceived(message);
			
		}
	}

	protected _OnMessageReceived(message: IScreenProtocolMessage)
	{
		let otherScreen = this.otherScreens.get(message.from);
		if (otherScreen != null) {
			otherScreen.ResetLastInteraction();
		}

		if (message.to == this.screenName || message.to == ScreenProtocolDestination.Broadcast.destination) {

			if (message.from == this.screenName) {
				// received from myself? do not handle
				// Log.Debug(this.logGroup, "Received message from myself? Do not handle.");
				Log.Error(this.logGroup, "There are multiple screens communicating under the same name \"" + this.screenName + "\"");
				return;
			}

			let handled: boolean = false;

			let messageHandler: ScreenProtocolMessageHandler = null;
			messageHandler = this.receiveMessageHandlers.get(ScreenProtocol.AnyMessage);
			if (messageHandler) {
				messageHandler(message);
			}

			messageHandler = this.receiveMessageHandlers.get(this.ScopedMessageName(message.msg, message.scope))
			if (messageHandler != null)
			{

				messageHandler(message);
				handled = true;
			}
		}
	}

	protected OnMessageError(ev: MessageEvent) {
		if (this.connected) {
			// Log.Debug(this.logGroup, "Message error: ", ev);
		}
	}


	protected OnIntroduction(message: IScreenProtocolMessage) {
		if (message.to == "*") {
			this.Send(new ScreenIntroductionMessage(this.screenName), this.scope, new ScreenProtocolDestination(message.from));
		}
		else {

		}

		let m = message as ScreenIntroductionMessage;
		// Log.Debug(this.logGroup, "Introduction from " + m.from);
	}

	protected ScopedMessageName(messageName: string, scope: string): string {
		if (scope == null)
			return messageName;


		
		return scope + "." + messageName;
	}

	public CheckAlive(screen: OtherScreen) {
		this.otherScreens.set(screen.name, screen);

		if (this.connected) {
			screen.ResetLastInteraction();
		}
	}


	protected receiveMessageHandlers: Map<string, ScreenProtocolMessageHandler> = new Map<string, ScreenProtocolMessageHandler>();
	public AddReceiveMessageHandler(messageName: string, messageHandler: ScreenProtocolMessageHandler, scope: string | ScreenProtocolScope = null): void {
		if (scope instanceof ScreenProtocolScope)
			this.receiveMessageHandlers.set(this.ScopedMessageName(messageName, scope.scope), messageHandler);
		else
			this.receiveMessageHandlers.set(this.ScopedMessageName(messageName, scope), messageHandler);
	}

	protected sendMessageHandler: Map<string, ScreenProtocolMessageHandler> = new Map<string, ScreenProtocolMessageHandler>();
	public AddSendMessageHandler(messageName: string, messageHandler: ScreenProtocolMessageHandler, scope: string | ScreenProtocolScope = null): void {
		if (scope instanceof ScreenProtocolScope)
			this.sendMessageHandler.set(this.ScopedMessageName(messageName, scope.scope), messageHandler);
		else 
			this.sendMessageHandler.set(this.ScopedMessageName(messageName, scope), messageHandler);
	}
}

//


// messages
export class ScreenPingMessage extends ScreenProtocolMessage
{
	public static readonly msgname = "ping";
	public screenName: string;

	constructor() {
		super(ScreenPingMessage.msgname);
	}
}

export class ScreenIntroductionMessage extends ScreenProtocolMessage
{
	public static readonly msgname = "introduction";
	public screenName: string;

	constructor(screenName: string) {
		super(ScreenIntroductionMessage.msgname);
		this.screenName = screenName;
	}
}

export class ScreenReloadMessage extends ScreenProtocolMessage
{
	public static readonly msgname = "reload";
	public screenName: string;

	constructor() {
		super(ScreenReloadMessage.msgname);
	}
}

export class ScreenLoadInfoMessage extends ScreenProtocolMessage
{
	public static readonly msgname = "machineinfo";
	public machineInfo: LoadInfo = null;

	constructor(machineInfo: LoadInfo) {
		super(ScreenLoadInfoMessage.msgname);
		this.machineInfo = machineInfo;
	}
}

export class ScreenGameInitDataMessage extends ScreenProtocolMessage
{
	public static readonly msgname = "gameinitdata";
	public gameInitData: SlotGameInitData = null;

	constructor(gameInitData: SlotGameInitData) {
		super(ScreenGameInitDataMessage.msgname);
		this.gameInitData = gameInitData;
	}
}

export class ScreenLoadingMessage extends ScreenProtocolMessage
{
	public static readonly msgname = "loading";

	constructor() {
		super(ScreenLoadingMessage.msgname);
	}
}

export class ScreenLoadProgressMessage extends ScreenProtocolMessage
{
	public static readonly msgname = "loading";
	public percent: number;

	constructor(percent: number) {
		super(ScreenLoadProgressMessage.msgname);
		this.percent = percent;
	}
}

export class ScreenLoadFinishedMessage extends ScreenProtocolMessage
{
	public static readonly msgname = "loaded";

	constructor() {
		super(ScreenLoadFinishedMessage.msgname);
	}
}

export class ScreenSelectedInMenuMessage extends ScreenProtocolMessage
{
	public static readonly msgname = "menugameselected";
	public gameid: number;

	constructor(gameid: number) {
		super(ScreenSelectedInMenuMessage.msgname);

		this.gameid = gameid;
	}
}


export class ScreenGameSelectedMessage extends ScreenProtocolMessage
{
	public static readonly msgname = "gameselected";
	public gameName: string;

	constructor(gameName: string) {
		super(ScreenGameSelectedMessage.msgname);

		this.gameName = gameName;
	}
}

export class ScreenGameMenuMessage extends ScreenProtocolMessage
{
	public static readonly msgname = "gamemenu";
	public gameid: string;

	constructor() {
		super(ScreenGameMenuMessage.msgname);
	}
}

export class ScreenMultigameSyncMessage extends ScreenProtocolMessage
{
	public static readonly msgname = "multigamesync";
	public selectedGameName: string;
	public selectedGameNameInMenu: string;

	constructor(selectedGameName: string, selectedGameInMenu: string) {
		super(ScreenMultigameSyncMessage.msgname);

		this.selectedGameName = selectedGameName;
		this.selectedGameNameInMenu = selectedGameInMenu;
	}
}

export class ScreenSlotGameSyncMessage extends ScreenProtocolMessage
{
	public static readonly msgname = "slotgamesync";
	public state: number;

	constructor(state: number) {
		super(ScreenSlotGameSyncMessage.msgname);

		this.state = state;
	}
}

// message, that is sent when language is changed
// export class ScreenLanguageSelectedMessage extends ScreenProtocolMessage
// {
// 	public static readonly msgname = "langchange";
// 	public locality: string;

// 	constructor (locality: string)
// 	{
// 		super(ScreenLanguageSelectedMessage.msgname);
// 		this.locality = locality;
// 	}
// }

export class AnimationStopRequest extends ScreenProtocolMessage
{
	public static readonly msgname = "animstoprequest";

	constructor() { 
		super(AnimationStopRequest.msgname);
	}
}

export class AnimationStartRequest extends ScreenProtocolMessage
{
	public static readonly msgname = "animstartrequest";

	constructor() { 
		super(AnimationStartRequest.msgname);
	}
}
export class JackpotValuesUpdate2 extends ScreenProtocolMessage
{
	public static readonly msgname = "jpvalues2";

	public values: JackpotValue2[] = null;

	constructor(values: JackpotValue2[]) {
		super(JackpotValuesUpdate2.msgname);

		this.values = values;
	}

}

export class JackpotValuesResume extends ScreenProtocolMessage
{
	public static readonly msgname = "jackpotValuesResume";
	constructor() {
		super(JackpotValuesResume.msgname);
		//console.log("JackpotValuesResume")		
	}
}

export class JackpotValuesPause extends ScreenProtocolMessage
{
	public static readonly msgname = "jackpotValuesPause";
	constructor() {
		super(JackpotValuesPause.msgname);
		//console.log("JackpotValuesPause")		
	}
}

export class JackpotValuesReset extends ScreenProtocolMessage
{
	public static readonly msgname = "jackpotValuesReset";
	public jackpotLevel : JackpotLevel []= null;
	constructor(jackpotLevel : JackpotLevel[]) {
		super(JackpotValuesReset.msgname);
		console.log("JackpotLevelForReset:",jackpotLevel)	
		this.jackpotLevel = jackpotLevel;	
	}
}


// export class LoadInfoGames extends ScreenProtocolMessage
// {
// 	public static readonly msgname = "loadinfogames";

// 	public loadInfo : LoadInfo;

// 	constructor(loadInfo:LoadInfo) {
// 		super(LoadInfoGames.msgname);
// 		this.loadInfo = loadInfo;	
// 		console.log("Message:",this.loadInfo);	
// 	}

// }


